import { difference, omit } from 'lodash';

const initState = {
  storedDictionaries: [],
  dictionariesPagination: {},
  isFetching: false,
};

function dictionaries(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'INIT_DICTIONARY':
      return { ...state, [action.name]: action.dictionary };
    case 'REMOVE_DICTIONARY':
      return { ...omit(state, action.dictionaryType) };
    case 'SET_FETCHING':
      return { ...state, isFetching: action.isFetching };
    case 'SAVE_DICTIONARY_PAGINATION':
      return {
        ...state,
        dictionariesPagination: { ...state.dictionariesPagination, [action.name]: action.paginationObj },
      };
    case 'STORE_DICTIONARIES':
      return { ...state, storedDictionaries: { ...state.storedDictionaries, ...action.dictionaries } };
    case 'ADD_ITEM':
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          dictionary: [...state[action.name].dictionary, action.item],
        },
      };
    case 'EDIT_ITEM':
      return {
        ...state,
        [action.item.type]: {
          ...state[action.item.type],
          dictionary: state[action.item.type].dictionary.map((item) => {
            if (item.uuid === action.uuid) {
              return { ...item, ...action.item };
            }

            return item;
          }),
        },
      };
    case 'TOGGLE_SELECTED_DICTIONARY': {
      let selected = [];

      if (state[action.dictionaryType].selected.includes(action.uuid)) {
        selected = difference(state[action.dictionaryType].selected, [action.uuid]);
      } else {
        selected = state[action.dictionaryType].selected.concat([action.uuid]);
      }

      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          selected,
        },
      };
    }
    case 'TOGGLE_SELECTED_ALL_DICTIONARIES': {
      let selected = [];

      selected = state[action.dictionaryType].dictionary.map((item) => item.uuid);

      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          selected,
        },
      };
    }
    case 'DESELECT_ALL_DICTIONARIES': {
      const selected = [];

      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          selected,
        },
      };
    }
    case 'IMPORT_DICTIONARY_START':
      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          importing: true,
        },
      };
    case 'IMPORT_DICTIONARY_RESULT':
      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          importErrors: action.errors,
          linesWithErrorsCount: action.linesWithErrorsCount,
          importing: false,
          importWasProduced: true,
        },
      };
    case 'SET_IMPORT_DICTIONARY_VALIDATE_FILE_RESULT':
      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          importErrors: action.errors,
          importRowsCount: action.importRowsCount,
        },
      };
    case 'CLEAR_IMPORT_DICTIONARY_STATE':
      return {
        ...state,
        [action.dictionaryType]: {
          ...state[action.dictionaryType],
          importErrors: [],
          linesWithErrorsCount: 0,
          importRowsCount: 0,
          importing: false,
          importWasProduced: null,
        },
      };
    default:
      return state;
  }
}

export default dictionaries;
